'use strict';

angular.module('amexReconciliationApp')
  .component('advancedSearchCriterion', {
    templateUrl: 'scripts/views/components/advanced-search-criterion.html',
    bindings: {
      criterion: '<',
      index: '<'
    },
    controller: function (SearchModel,
                          SiteConfigModel,
                          TransactionsModel,
                          UserModel,
                          dateFormats,
                          $translate) {

      var self = this;

      self.$onChanges = function () {
        self.selectedField = getSelectedField();
      };

      self.$onInit = function () {
        self.fieldTypes = getFieldTypes();
        self.dropdownValues = getDropdownValues();
        self.selectedField = getSelectedField();
      };

      self.receivedStatuses = ['FULLY_RECEIVED','PARTIALLY_RECEIVED','NOT_RECEIVED'];
      self.transactionStatuses = ['REVIEWED', 'REALLOCATED', 'NOT_REVIEWED'];
      var lockStatuses = ['UNLOCKED', 'PARTIALLY_LOCKED', 'FULLY_LOCKED'];
      var oibLockStatuses = ['UNLOCKED', 'PARTIALLY_LOCKED', 'FULLY_LOCKED', 'HELD'];

      self.dateFormat = dateFormats[UserModel.currentUserPreferences().dateFormat];
      self.today = new Date();
      self.datePickers = _.fill(Array(2), false);

      self.updateCriterion = function () {
        SearchModel.updateCriterion(self.criterion);
      };

      self.maxFromDate = function () {
        if( !self.criterion.fieldValue.to || self.criterion.fieldValue.to === '' ) {
          return self.today;
        }
        return self.criterion.fieldValue.to;
      };

      self.getType = function () {
        return SearchModel.getType(self.criterion);
      };
      
      self.operators = function () {
        return SearchModel.operators(self.criterion);
      };

      self.isDefaultFieldType = function () {
        return self.criterion.fieldType === '';
      };

      self.toggleDatePicker = function (offset) {
        self.datePickers[offset] = !self.datePickers[offset];
      };

      self.getLockStatuses = function () {
        if(SiteConfigModel.isOibEnabled()){
          return oibLockStatuses;
        } else {
          return lockStatuses;
        }
      };

      self.handleSelectedField = function () {
        self.criterion.fieldType = self.selectedField.name;
        self.updateCriterion();
        self.dropdownValues = getDropdownValues();
      };

      self.displayDropdown = function() {
        return self.criterion.operator === 'STRING_EXACT';
      };

      function getCategoryName(category) {
        if (!category) {
          return '';
        }
        return $translate.instant('transactions.search.categories.' + category);
      }

      function getDisplayName(fieldName) {
        if (!fieldName) {
          return '';
        }
        var accountingFieldMatch = fieldName.match(/^ACCOUNTING_FIELD_(\d+)$/);
        if (accountingFieldMatch) {
          var position = Number(accountingFieldMatch[1]);
          var accountingFieldSchemas = _.get(SiteConfigModel.siteConfig(), 'accountingFieldSchemas', []);
          var label = _.get(_.find(accountingFieldSchemas, ['position', position]), 'label');
          return label;
        }  else {
          return $translate.instant('transactions.search.fieldTypes.' + fieldName);
        }
      }

      function getSelectedField() {
        var fieldTypeName = _.get(self.criterion, 'fieldType', undefined);
        var fields = SearchModel.getFields();
        if (fieldTypeName) {
          return getFieldType(fieldTypeName,fields);
        }
        return undefined;
      }

      function getFieldType(fieldName, fields) {
        var category;

        category = _.get(fields[fieldName],'category');
        return {'name': fieldName, 'translatedName': getDisplayName(fieldName), 'category': getCategoryName(category)};
      }

      function getFieldTypes() {
        var fields = SearchModel.getFields();

        var fieldTypes = _.map(_.keys(fields), function(fieldName) {
          return getFieldType(fieldName,fields);
        });
        return fieldTypes;
      }

      function getDropdownValues() {
        var fieldTypeName = _.get(self.criterion, 'fieldType', undefined);

        switch(fieldTypeName) {
          case 'CARDMEMBER_NAME':
            return getCardmemberNames();
          case 'MERCHANT_NAME':
            return getMerchantNames();
          default:
            return [];
        }
      }

      function getCardmemberNames() {
        return _
          .chain(TransactionsModel.transactions())
          .map('cardmemberName')
          .uniq()
          .sortBy()
          .value();
      }

      function getMerchantNames() {
        return _
          .chain(TransactionsModel.transactions())
          .flatMap(function(transaction) {
            return [_.get(transaction, 'merchantName'), _.get(transaction, 'merchantName2')];
          })
          .filter(function(name) {
            return name !== '' && name;
          })
          .uniq()
          .sortBy()
          .value();
      }

    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/advancedSearchCriterion.js
// module id = 431
// module chunks = 0